//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TypesDropdown from '@/components/search/TypesDropdown'
import TaskLocationDropdown from '@/components/search/TaskLocationDropdown'
import { mapState } from 'vuex'
import SkillsDropdown from '@/components/search/SkillsDropdown'
import QuickSearch from '../ui/QuickSearch.vue'
import CategoriesDropdown from './CategoriesDropdown.vue'
import SortDropdown from './SortDropdown.vue'
import LanguagesDropdown from '~/components/search/LanguagesDropdown'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'SearchHeading',
  components: {
    SkillsDropdown,
    TaskLocationDropdown,
    TypesDropdown,
    QuickSearch,
    SortDropdown,
    CategoriesDropdown,
    LanguagesDropdown
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('search', {
      category: 'category',
      skill: 'skill',
      type: 'type',
      languages: 'languages',
      sort: 'sort',
      queryTerm: 'queryTerm',
      location: 'location'
    }),
    skillDisabled () {
      return this.disabled || !this.category
    }
  },
  methods: {
    selectSort (c) {
      this.$emit('sort', c)
    },
    search (term) {
      this.$store.commit('search/setQueryTerm', term)
      this.$emit('search')
    },
    selectCategory (c) {
      this.$store.commit('search/setCategory', c)
      this.$store.commit('search/setSkill', null)
      this.$emit('search')
    },
    selectSkill (c) {
      this.$store.commit('search/setSkill', c)
      this.$emit('search')
    },
    selectLanguages (languages) {
      this.$store.commit('search/setLanguages', languages)
      this.$emit('search')
    },
    selectType (type) {
      this.$store.commit('search/setType', type)
      this.$emit('search')
    },
    selectLocation (location) {
      this.$store.commit('search/setLocation', location)
      this.$emit('search')
    }
  }
}
